// src/components/Footer.js

import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/images/logo-chef.png'; // Asegúrate que la ruta sea correcta

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto py-8 px-6">
        <div className="flex flex-wrap justify-between items-center">
          <div className="flex items-center mb-4 md:mb-0">
            <img src={logo} alt="Logo" className="h-10 w-10 rounded-full" />
            <span className="font-bold text-xl ml-2">Banquetes</span>
          </div>
          <div className="flex space-x-6">
            <NavLink to="/" className="text-gray-600 hover:text-indigo-600">Inicio</NavLink>
            <NavLink to="/catalogo" className="text-gray-600 hover:text-indigo-600">Catálogo</NavLink>
            <NavLink to="/nosotros" className="text-gray-600 hover:text-indigo-600">Nosotros</NavLink>
            <NavLink to="/contacto" className="text-gray-600 hover:text-indigo-600">Contacto</NavLink>
          </div>
        </div>
        <div className="mt-8 text-center text-sm text-gray-500 border-t border-gray-100 pt-6">
          <p>&copy; {new Date().getFullYear()} Banquetes del Chef. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;